import React, { useEffect, useState } from "react";
import { NavLink, useOutletContext } from "react-router-dom";
import {
  extractMatricDigits,
  getClassDetailsDirect,
  showSwal,
  updateClassAdmission,
  updateCurrentClass,
} from "../../AppManager";
import ConfirmAction from "../../components/ConfirmAction";

function OverviewClass() {
  const { user, record, setRecord } = useOutletContext();
  const [classInfo, setClassInfo] = useState({
    name: "",
    teacher: "",
    "teacher matric": "RUN/ABC/12/3456",
    assistant: "",
    "assistant matric": "RUN/ABC/12/3456",
    location: "",
    students: "",
    centre: "",
    trainingClass: "",
    admission: true,
    currentClass: true,
  });
  const [close, setClose] = useState(true);
  const [actionEvent, setActionEvent] = useState({});

  useEffect(() => {
    getClassDetailsDirect(user.class)
      .then((classInfo) => {
        setClassInfo(classInfo);
      })
      .catch((err) => err);
  }, [user, record]);

  async function toggleAdmission(e) {
    const { name, type, value } = e.target;
    if (name === "admission" && type === "button") {
      const res = await updateClassAdmission({
        name: classInfo.name,
        admission: value,
      });
      if (res === "Updated") {
        setClassInfo((oldClassInfo) => {
          return { ...oldClassInfo, [name]: value };
        });
        setRecord((oldRecord) => {
          let lasses =
            oldRecord[classInfo.centre][classInfo.trainingClass].classes;
          for (let l = 0; l < lasses.length; l++) {
            let currC = lasses[l];
            if (currC.name === classInfo.name) {
              lasses[l] = { ...currC, [name]: value };
            }
          }
          return {
            ...oldRecord,
            [classInfo.centre]: {
              ...oldRecord[classInfo.centre],
              [classInfo.trainingClass]: {
                ...oldRecord[classInfo.centre][classInfo.trainingClass],
                classes: lasses,
              },
            },
          };
        });
        showSwal(
          !classInfo.admission ? "success" : "info",
          `Admission ${!classInfo.admission ? "Opened" : "Closed"}`
        );
      } else {
        showSwal("error", "Failed");
      }
    }
  }

  function toggleClass(e) {
    const { name, type, checked } = e.target;
    setActionEvent({ name, type, checked });
    setClose(false);
  }

  async function toggleClassConfirmed({ name, type, value }) {
    if (name === "currentClass" && type === "checkbox") {
      const res = await updateCurrentClass({
        name: classInfo.name,
        currentClass: value,
      });
      if (res === "Updated") {
        setClassInfo((oldClassInfo) => {
          return { ...oldClassInfo, [name]: value };
        });
        setRecord((oldRecord) => {
          let lasses =
            oldRecord[classInfo.centre][classInfo.trainingClass].classes;
          for (let l = 0; l < lasses.length; l++) {
            let currC = lasses[l];
            if (currC.name === classInfo.name) {
              lasses[l] = { ...currC, [name]: value, students: 0 };
            }
          }
          return {
            ...oldRecord,
            [classInfo.centre]: {
              ...oldRecord[classInfo.centre],
              [classInfo.trainingClass]: {
                ...oldRecord[classInfo.centre][classInfo.trainingClass],
                classes: lasses,
              },
            },
          };
        });
        showSwal(
          !classInfo.currentClass ? "success" : "info",
          `Classes ${!classInfo.currentClass ? "Started" : "Closed"}`
        );
      } else if (res === "Exists") {
        showSwal("error", "Record Exists");
      } else if (res === "Empty") {
        showSwal("error", "Record Empty");
      } else {
        showSwal("error", "Failed");
      }
    }
  }

  return (
    <div className="overview-class">
      {!close && (
        <ConfirmAction
          currUser={user}
          setClose={setClose}
          confirmed={() => {
            toggleClassConfirmed(actionEvent);
          }}
        />
      )}
      <h1 className="heading1">{classInfo.name}</h1>
      <div>
        <div>
          <h1 className="heading3" style={{ textAlign: "left" }}>
            Teacher:
          </h1>
          <span>
            <NavLink
              to={`/overview/teacher/${extractMatricDigits(
                classInfo["teacher matric"]
              )}`}
            >
              {classInfo.teacher}
            </NavLink>
          </span>
        </div>
        <div>
          <h1 className="heading3" style={{ textAlign: "left" }}>
            Assistant Teacher:
          </h1>
          <span>
            <NavLink
              to={`/overview/teacher/${extractMatricDigits(
                classInfo["assistant matric"]
              )}`}
            >
              {classInfo["assistant"]}
            </NavLink>
          </span>
        </div>
        <div>
          <h1 className="heading3" style={{ textAlign: "left" }}>
            Centre:
          </h1>
          <span>{classInfo.centre}</span>
        </div>
        <div>
          <h1 className="heading3" style={{ textAlign: "left" }}>
            Training Class:
          </h1>
          <span>{classInfo.trainingClass}</span>
        </div>
        <div>
          <h1 className="heading3" style={{ textAlign: "left" }}>
            Location:
          </h1>
          <span>{classInfo.location}</span>
        </div>
        <div>
          <h1 className="heading3" style={{ textAlign: "left" }}>
            Number of Students:
          </h1>
          <span>
            <NavLink to="/overview/students">{classInfo.students}</NavLink>
          </span>
        </div>
        <div>
          <h1 className="heading3" style={{ textAlign: "left" }}>
            Admission:
          </h1>
          <span className="checkbox-wrapper">
            <button
              type="button"
              className="text-btn sp-btn"
              name="admission"
              style={{
                fontSize: "1em",
                fontWeight: "bolder",
                backgroundColor: !classInfo.admission
                  ? "green"
                  : "rgb(195, 6, 6)",
                border: "none",
              }}
              onClick={toggleAdmission}
              value={!classInfo.admission}
            >
              {classInfo.admission ? "CLOSE" : "OPEN"}
            </button>
            <p
              style={{
                color: classInfo.admission ? "green" : "rgb(195, 6, 6)",
              }}
            >
              Currently {classInfo.admission ? "Open" : "Closed"}
            </p>
          </span>
        </div>
        <div>
          <h1 className="heading3" style={{ textAlign: "left" }}>
            Class:
          </h1>
          <span className="checkbox-wrapper">
            <button
              type="button"
              className="text-btn sp-btn"
              name="classclose"
              style={{
                fontSize: "1em",
                fontWeight: "bolder",
                backgroundColor: !classInfo.currentClass
                  ? "green"
                  : "rgb(195, 6, 6)",
                border: "none",
              }}
              onClick={toggleClass}
              value={classInfo.currentClass ? "CLOSE" : "START"}
            >
              {classInfo.currentClass ? "CLOSE" : "START"}
            </button>
            <p
              style={{
                color: classInfo.currentClass ? "green" : "rgb(195, 6, 6)",
              }}
            >
              Currently {classInfo.currentClass ? "Ongoing" : "Closed"}
            </p>
          </span>
        </div>
      </div>
    </div>
  );
}

export default OverviewClass;
